module.exports = __webpack_public_path__ + "static/7-60572025e5e35319344b87c2f5a71013.jpeg";